module.exports = __webpack_public_path__ + "static/img/19.257c07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/19.png
// module id = xTmB
// module chunks = 1